/*
 * Public API Surface of aumico templates
 */
export * from './lib/index';
